"use client";

import { useEffect, useRef } from "react";
import { clientLogger } from "@oxpa/shared/lib/logger/client";

export function LddGlobalCatcher() {
    const sessionTracked = useRef(false);

    useEffect(() => {
        if (process.env.NODE_ENV !== "development") return;

        const errorHandler = (event: ErrorEvent) => {
            clientLogger.error("Uncaught Browser Error", {
                message: event.message,
                filename: event.filename,
                lineno: event.lineno,
                colno: event.colno,
                error: event.error?.stack || event.error,
            });
        };

        const promiseRejectionHandler = (event: PromiseRejectionEvent) => {
            clientLogger.error("Unhandled Promise Rejection", {
                reason: event.reason?.stack || event.reason,
            });
        };

        window.addEventListener("error", errorHandler);
        window.addEventListener("unhandledrejection", promiseRejectionHandler);

        // Guard: отправляем SESSION STARTED только один раз (StrictMode fix)
        if (!sessionTracked.current) {
            sessionTracked.current = true;
            clientLogger.ldd_trace("CLIENT SESSION STARTED", {
                url: window.location.href,
            });
        }

        return () => {
            window.removeEventListener("error", errorHandler);
            window.removeEventListener(
                "unhandledrejection",
                promiseRejectionHandler,
            );
        };
    }, []);

    return null;
}
